import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.reduce";
import _ from "lodash";
import customMerge from "./customMerge";

function isStyleVariant(propertyName) {
  return /^\./.test(propertyName);
}

function isChildStyle(propertyName) {
  return /(^[^\.].*\.)|^\*$/.test(propertyName);
}

function splitStyle(style) {
  return _.reduce(style, function (result, value, key) {
    var styleSection = result.componentStyle;

    if (isStyleVariant(key)) {
      styleSection = result.styleVariants;
    } else if (isChildStyle(key)) {
      styleSection = result.childrenStyle;
    }

    styleSection[key] = value;
    return result;
  }, {
    componentStyle: {},
    styleVariants: {},
    childrenStyle: {}
  });
}

export function resolveComponentStyle(componentName) {
  var styleNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var themeStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var parentStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var themeCache = arguments.length > 4 ? arguments[4] : undefined;
  var mergedStyle = customMerge(themeStyle, parentStyle[componentName]);
  styleNames.forEach(function (sn, index) {
    mergedStyle = customMerge(mergedStyle, themeStyle["" + sn]);
  });
  styleNames.forEach(function (sn, index) {
    mergedStyle = customMerge(mergedStyle, parentStyle["" + componentName + sn]);
  });
  var resolvedStyle = customMerge(mergedStyle, parentStyle[componentName]);
  styleNames.forEach(function (sn, index) {
    resolvedStyle = customMerge(resolvedStyle, mergedStyle["" + sn]);
  });
  styleNames.forEach(function (sn, index) {
    resolvedStyle = customMerge(resolvedStyle, parentStyle["" + componentName + sn]);
  });
  return resolvedStyle;
}